import * as Styled from './styled';
import React from 'react';

interface Props {
	text: String;
	forwardedRef?: any;
}

const SmallCapHeader: React.FunctionComponent<Props> = (props: Props) => (
	/**
	 * Should be able to use passRef from Toolkit to achieve this (need doco)
	 */
	<div ref={props.forwardedRef}>
		<Styled.Header el="h1" fontSize="big" tabIndex="-1">
			{props.text}
		</Styled.Header>
	</div>
);

export default SmallCapHeader;
